import { all, fork } from "redux-saga/effects";

//layout
import LayoutSaga from "./layouts/saga";

//Auth
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import CustomerSaga from "./customer/saga";
import ProductSaga from "./product/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import StoreSaga from "./outlet/saga";
export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(CustomerSaga),
    fork(ProductSaga),
    fork(StoreSaga),
  ]);
}
